import { DEFAULT_LANGUAGE, LANGUAGE_LOCALES, Language, Translation } from 'src/models/Language'

export const getLanguageByCode = (code: string): Language => {
    if (!code) {
        console.warn('[TranscriptMetadata] Missing language code in configuration')

        return DEFAULT_LANGUAGE
    }

    const codesMap: Record<string, Language> = Object.entries(LANGUAGE_LOCALES).reduce((acc, [lang, codes]) => {
        const curr: Record<string, Language> = {}
        codes.forEach((langCode) => {
            curr[langCode] = lang as Language
        })

        return {
            ...acc,
            ...curr,
        }
    }, {})

    // the code is expected to be coming from BE as a combination of ISO 639-1 (language) and
    // ISO 3166-1 Alpha-2 (country) - e.g. "en-US" - of which we only care about the language
    const langPart = code.split('-')[0]
    const language = codesMap[langPart]
    if (!language) {
        console.warn(`[TranscriptMetadata] Unexpected language code: ${code}`)

        return DEFAULT_LANGUAGE
    }

    return language
}

export const getLanguagePresentation = (code: string, translations: Translation[]) => {
    const targetTranslation = translations.find((t) => t.code === code)

    return targetTranslation?.name || ''
}
